export default "__VITE_ASSET__DOw9$kDO__"